<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-input v-model="name" placeholder="请输入名称" style="width: 200px;"></el-input>
    <el-button type="success" @click="query" icon="el-icon-search" style="float: right;background-color: #209323;">查询</el-button>
    <el-table
      :data='tableData'
      style="width: 100%; margin-top: 10px;">
      <el-table-column
        fixed
        prop= 'id'
        label= '编号'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'name'
        label= '名称'>
      </el-table-column>
      <el-table-column
        prop= 'serialNo'
        label= '序列号'
        width= '200'>
      </el-table-column>
      <el-table-column
        prop= 'authCode'
        label= '验证码'
        width= '100'>
      </el-table-column>
      <el-table-column
        prop= 'deviceProjectName'
        label= '所属产品'
        width= '160'>
      </el-table-column>      
      <el-table-column
        prop= 'deviceModelVersion'
        label= '模型版本号'
        width= '160'>
      </el-table-column>
      <el-table-column
        prop= 'mac'
        label= 'mac地址'
        width= '160'>
      </el-table-column>
      <el-table-column
        prop= 'lineStatus'
        label= '在线状态'
        width= '80'>
        <template slot-scope='scope'>
          <el-button type='success' size='small' v-if="scope.row.lineStatus===1">在线</el-button>
          <el-button type='info' size='small' v-if="scope.row.lineStatus===0">离线</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop= 'otaVersion'
        label= '当前版本'
        width= '100'>
      </el-table-column>  
      <el-table-column
        prop= 'onlineTime'
        label= '最近连接时间'
        width= '160'>
      </el-table-column>      
      <el-table-column
        prop= 'onilneTimer'
        label= '连接次数'
        width= '100'>
      </el-table-column>
      <el-table-column
        prop= 'addTime'
        label= '添加时间'
        width= '160'>
      </el-table-column>     

      <el-table-column
        fixed= 'right'
        label= '操作'
        width= '100'>
        <template slot-scope='scope'>
          <el-button @click='reboot(scope.row)' type='text' size='small' style="color: #209323">重启设备</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="text-align: right;margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-row>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
export default {
  components: {
  },
  props: {
  },
  data () {
    return {
      tableData: [],
      name: '',
      dialogFormVisible: false,
      formLabelWidth: '120px',
      current: 1,
      pageSize: 10,
      total: 0,
      pages: 0,
      deviceProjects: [],
      deviceModels: [],
      apiUrl: '',
    }
  },
  created () {
    this.apiUrl = this.$global.apiUrl
    this.queryDeviceProjects()
  },
  watch: {
  },
  methods: {
    reboot (row) {
      let that = this
      requestService.post(`/deviceInstantiation/reboot`, {serialNo: row.serialNo
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
      })
    },
    query () {
      let that = this
      requestService.get(`/deviceInstantiation/listPageForAdmin?current=${that.current}&pageSize=${that.pageSize}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        // console.log(res)
        that.tableData = res.data.body.records
        for(let item of that.tableData){
          for(let project of that.deviceProjects){
            if(project.id==item.deviceProjectId){
              item.deviceProjectName = project.name
              break;
            }
          }
        }
        console.log('........', that.tableData)
        that.total = res.data.body.total
        that.pages = res.data.body.pages
      })
    },
    queryDeviceProjects () {
      let that = this
      requestService.get(`/deviceProject/listPage?current=1&pageSize=1024000`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.deviceProjects = res.data.body.records
        that.query()
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.current = val
      this.query()
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/manage-components/deviceInstantiation/Index.vue